<template>
  <Breadcrumb :items="breadcrumbItems" />
  <div class="cabecalho">
    <div>
      <h2>MEU PERFIL</h2>
    </div>
  </div>

  <div id="perfil-containder">
    <div class="perfil-body">
      <!-- Cabeçalho do perfil -->
      <div class="perfil-header">
        <!-- Input file oculto -->
        <input
          ref="inputImagem"
          type="file"
          accept="image/*"
          style="display: none"
          @change="processarImagem"
        />

        <!-- Imagem clicável -->
        <div
          class="img-perfil"
          :class="{ editavel: modoEditar }"
          @click="abrirSeletorImagem()"
        >
          <img
            v-if="imagemPreview"
            :src="imagemPreview"
            alt="Foto de perfil"
          />
          <img
            v-else-if="userData.imagemUrl"
            :src="userData.imagemUrl"
            alt="Foto de perfil"
          />
          <img
            v-else
            src="@/assets/ix_user-profile-filled.png"
            alt="Foto de perfil"
          />
          <div
            v-if="modoEditar"
            class="icone-editar-foto"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
              />
              <circle
                cx="12"
                cy="13"
                r="4"
              />
            </svg>
          </div>

          <button
            v-if="modoEditar && (imagemPreview || userData.imagemUrl)"
            class="btn-remover-foto"
            @click.stop="removerImagem()"
            title="Remover foto"
          >
            Remover Foto
          </button>
        </div>

        <div class="nome">
          <div class="nome-email">
            <h2>{{ nome }}</h2>
            <p>{{ email }}</p>
          </div>
          <div class="nacionalidade">
            <p>{{ nacionalidade }}</p>
          </div>
        </div>
      </div>

      <div id="edicao-credenciais">
        <button
          class="btn-editar-credencial"
          :disabled="carregando"
          @click="toggleMudarEmail = true"
        >
          Alterar Email
        </button>
        <button
          class="btn-editar-credencial"
          :disabled="carregando"
          @click="mudarSenha"
        >
          Alterar Senha
        </button>
      </div>

      <!-- Informações pessoais -->
      <div class="informacoes-perfil">
        <h3>INFORMAÇÕES PESSOAIS</h3>
        <Carregamento v-if="carregando" />
        <div
          class="campos-infos"
          v-else
        >
          <!-- Data de Nascimento -->
          <div class="mb-3">
            <label class="form-label">Data de nascimento</label>
            <input
              type="date"
              class="form-control"
              :class="{ 'input-invalido': erros.dataNascimento }"
              v-model="userData.dataNascimento"
              :disabled="verificacaoNumero || !modoEditar"
              :max="hoje"
              @change="validarDataNascimento"
            />
            <span
              v-if="erros.dataNascimento"
              class="msg-erro"
              >Formato inválido!</span
            >
          </div>

          <!-- Telefone -->
          <div class="mb-3">
            <label class="form-label">Telefone</label>
            <input
              type="tel"
              class="form-control"
              :class="{ 'input-invalido': erros.telefone }"
              v-model="userData.telefone"
              :disabled="!modoEditar"
              maxlength="19"
              placeholder="+55 (00) 00000-0000"
              v-maska="'+## (##) 9####-####'"
              @blur="validarTelefone"
            />
            <span
              v-if="erros.telefone"
              class="msg-erro"
              >Formato inválido!</span
            >
          </div>

          <!-- CPF (sempre desabilitado) -->
          <div class="mb-3">
            <label class="form-label">CPF</label>
            <input
              type="text"
              class="form-control"
              v-model="userData.cpf"
              disabled
            />
          </div>

          <!-- Gênero -->
          <div class="mb-3">
            <label class="form-label">Gênero</label>
            <select
              class="form-control"
              v-model="userData.genero"
              :disabled="!modoEditar"
            >
              <option value="">Selecione...</option>
              <option
                v-for="item in genero"
                :key="item.valor"
                :value="item.valor"
              >
                {{ item.nome }}
              </option>
            </select>
          </div>

          <!-- Heteroidentificação -->
          <div class="mb-3">
            <label class="form-label">Heteroidentificação</label>
            <select
              class="form-control"
              v-model="userData.heteroidentificacao"
              :disabled="!modoEditar"
            >
              <option value="">Selecione...</option>
              <option
                v-for="item in heteroidentificacao"
                :key="item.valor"
                :value="item.valor"
              >
                {{ item.nome }}
              </option>
            </select>
          </div>

          <!-- Escolaridade -->
          <div class="mb-3">
            <label class="form-label">Escolaridade</label>
            <select
              class="form-control"
              v-model="userData.escolaridade"
              :disabled="!modoEditar"
            >
              <option value="">Selecione...</option>
              <option
                v-for="item in escolaridade"
                :key="item.valor"
                :value="item.valor"
              >
                {{ item.nome }}
              </option>
            </select>
          </div>

          <!-- Renda Familiar -->
          <div class="mb-3">
            <label class="form-label">Renda familiar</label>
            <select
              class="form-control"
              v-model="userData.rendaFamiliar"
              :disabled="!modoEditar"
            >
              <option value="">Selecione...</option>
              <option
                v-for="item in rendaFamiliar"
                :key="item.valor"
                :value="item.valor"
              >
                {{ item.nome }}
              </option>
            </select>
          </div>

          <!-- Zona de Moradia -->
          <div class="mb-3">
            <label class="form-label">Zona de moradia</label>
            <select
              class="form-control"
              v-model="userData.zonaMoradia"
              :disabled="!modoEditar"
            >
              <option value="">Selecione...</option>
              <option
                v-for="item in zonaMoradia"
                :key="item.valor"
                :value="item.valor"
              >
                {{ item.nome }}
              </option>
            </select>
          </div>

          <!-- Unidade de Origem (Somente SIGAA) -->
          <div
            class="mb-3"
            v-if="isSigaaUser"
          >
            <label class="form-label">Unidade de origem</label>
            <select
              class="form-control"
              v-model="userData.unidadeId"
              :disabled="!modoEditar"
            >
              <option value="">Selecione uma unidade...</option>
              <option
                v-for="item in unidadesDaUfc"
                :key="item.id"
                :value="item.id"
              >
                {{ item.nome }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <!-- Minhas Ações -->
      <div class="acoes-perfil">
        <h3>MINHAS AÇÕES</h3>
        <Carregamento v-if="carregando" />
        <div
          class="acoes-vinculadas"
          v-else
        >
          <div
            v-for="(acao, index) in acoes"
            :key="index"
            class="acao-card"
            @click="abrirAcao(acao.acao_id || acao.id)"
          >
            <p><span>Título da ação:</span> {{ acao.titulo }}</p>
            <p><span>Período da ação:</span> {{ formatarPeriodoAcao(acao) }}</p>
            <p>
              <span>Tipo de membro:</span>
              {{ acao.funcao_membro || acao.funcaoMembro || "Participante" }}
            </p>
            <p>
              <span>Área temática:</span>
              {{ acao.areaTematica || acao.area_tematica || "Indefinido" }}
            </p>
          </div>
        </div>
      </div>

      <!-- Botões -->
      <div class="acoes-botoes">
        <button
          v-if="!modoEditar"
          :disabled="carregando"
          class="btn-editar"
          @click="ativarEdicao"
        >
          Editar
        </button>
        <template v-else>
          <button
            class="btn-cancelar"
            @click="cancelarEdicao"
          >
            Cancelar
          </button>
          <button
            class="btn-salvar"
            @click="salvarEdicao()"
          >
            Salvar
          </button>
        </template>
      </div>
    </div>
  </div>

  <div
    class="cadastro"
    v-if="toggleMudarEmail"
  >
    <div id="voltar">
      <h4>Alterar Email</h4>
      <button @click.prevent="toggleMudarEmail = false">
        <img src="@/assets/Frame 523.png" />
      </button>
    </div>
    <form
      class="form"
      @submit.prevent="mudarEmail"
    >
      <div class="campos-form-container">
        <div class="campos-form">
          <div class="mb-3">
            <div class="label-container">
              <label
                for="email"
                class="form-label"
                >Novo email*</label
              >
            </div>
            <input
              type="email"
              id="nome"
              class="form-control"
              v-model="novoEmail"
              required
            />
          </div>
        </div>
        <div
          id="botoes"
          style="justify-content: center"
        >
          <button
            id="enviar"
            type="submit"
            class="btn btn-primary center"
          >
            Confirmar
          </button>
        </div>
      </div>
    </form>
  </div>

  <!-- Modal de aviso -->
  <Aviso
    :sucesso="sucesso"
    :texto="texto"
    @fecharModal="fecharAviso"
    v-if="aviso"
  />
</template>

<script setup>
import usuariosService from "@/service/usuariosService";
import unidadesService from "@/service/unidadesService";
import { ref, onMounted, computed } from "vue";
import { jwtDecode } from "jwt-decode";
import { formatarCPF, formatarData } from "@/utils/FormatarEntradas";
import router from "@/router";
import { vMaska } from "maska/vue";
import Aviso from "@/components/common/aviso.vue";
import Carregamento from "@/components/common/Carregamento.vue";
import Breadcrumb from "@/components/common/Breadcrumb.vue";

const nome = ref("");
const email = ref("");
const nacionalidade = ref("");
const modoEditar = ref(false);
const toggleMudarEmail = ref(false);
const novoEmail = ref("");
const verificacaoNumero = ref(false);
const isSigaaUser = ref(false);
const unidadesDaUfc = ref([]);

let snapshot = {};
let snapshotImagem = { preview: null, base64: null, mimeType: null };

const carregando = ref(false);

const hoje = new Date().toISOString().split("T")[0];

const aviso = ref(false);
const sucesso = ref(false);
const texto = ref("");

const breadcrumbItems = computed(() => {
  return [
    { label: "Início", to: "/" },
    { label: "Perfil", to: "/perfil" },
  ];
});

function fecharAviso() {
  aviso.value = false;
  if (sucesso.value) {
    window.location.reload();
  }
}

const inputImagem = ref(null);
const imagemPreview = ref(null);
const imagemBase64 = ref(null);
const imagemMimeType = ref(null);

function abrirSeletorImagem() {
  if (modoEditar.value) inputImagem.value.click();
}

function processarImagem(event) {
  const file = event.target.files[0];
  if (!file) return;

  const reader = new FileReader();
  reader.onload = () => {
    imagemPreview.value = reader.result;
    imagemMimeType.value = file.type;
    imagemBase64.value = reader.result.split(",")[1];
  };
  reader.onerror = () => {
    texto.value = "Erro ao processar a imagem.";
    sucesso.value = false;
    aviso.value = true;
  };
  reader.readAsDataURL(file);
}

const erros = ref({
  telefone: "",
  dataNascimento: "",
});

const userData = ref({
  telefone: "",
  cpf: "",
  genero: "",
  heteroidentificacao: "",
  dataNascimento: "",
  escolaridade: "",
  rendaFamiliar: "",
  zonaMoradia: "",
  unidadeId: "",
});

const heteroidentificacao = [
  { nome: "Pardo", valor: "PARDO" },
  { nome: "Branco", valor: "BRANCO" },
  { nome: "Negro", valor: "NEGRO" },
  { nome: "Indígena", valor: "INDIGENA" },
  { nome: "Amarelo", valor: "AMARELO" },
  { nome: "Prefiro não responder", valor: "PREFIRO_NAO_RESPONDE" },
];

const rendaFamiliar = [
  { nome: "Menos de 1 salário mínimo", valor: "MENOS_DE_1_SALARIO_MINIMO" },
  { nome: "De 1 a 3 salários mínimos", valor: "DE_1_A_3_SALARIOS_MINIMOS" },
  { nome: "De 4 a 7 salários mínimos", valor: "DE_4_A_7_SALARIOS_MINIMOS" },
  { nome: "Mais de 7 salários mínimos", valor: "MAIS_DE_7_SALARIOS_MINIMOS" },
  { nome: "Prefiro não responder", valor: "PREFIRO_NAO_RESPONDER" },
];

const genero = [
  { nome: "Homem cisgênero", valor: "HOMEM_CISGENERO" },
  { nome: "Homem transgênero", valor: "HOMEM_TRANSGENERO" },
  { nome: "Mulher cisgênero", valor: "MULHER_CISGENERO" },
  { nome: "Mulher transgênero", valor: "MULHER_TRANSGENERO" },
  { nome: "Gênero não-binário", valor: "GENERO_NAO_BINARIO" },
  { nome: "Agênero", valor: "AGENERO" },
  { nome: "Gênero-fluido", valor: "GENERO_FLUIDO" },
  { nome: "Bigênero", valor: "BIGENERO" },
  { nome: "Mulher transexual", valor: "MULHER_TRANSEXUAL" },
  { nome: "Homem transexual", valor: "HOMEM_TRANSEXUAL" },
  { nome: "Poligênero", valor: "POLIGENERO" },
  { nome: "Gênero neutro", valor: "GENERO_NEUTRO" },
  { nome: "Outro", valor: "OUTRO" },
  { nome: "Prefiro não responder", valor: "PREFIRO_NAO_RESPONDER" },
];

const escolaridade = [
  { nome: "Não alfabetizado", valor: "NAO_ALFABETIZADO" },
  {
    nome: "Ensino fundamental incompleto",
    valor: "ENSINO_FUNDAMENTAL_INCOMPLETO",
  },
  { nome: "Ensino fundamental completo", valor: "ENSINO_FUNDAMENTAL_COMPLETO" },
  { nome: "Ensino médio incompleto", valor: "ENSINO_MEDIO_INCOMPLETO" },
  { nome: "Ensino médio completo", valor: "ENSINO_MEDIO_COMPLETO" },
  { nome: "Ensino superior incompleto", valor: "ENSINO_SUPERIOR_INCOMPLETO" },
  { nome: "Ensino superior completo", valor: "ENSINO_SUPERIOR_COMPLETO" },
  { nome: "Prefiro não responder", valor: "PREFIRO_NAO_RESPONDER" },
];

const zonaMoradia = [
  { nome: "Zona Urbana", valor: "ZONA_URBANA" },
  { nome: "Zona Rural", valor: "ZONA_RURAL" },
  { nome: "Zona Periurbana", valor: "ZONA_PERIURBANA" },
  { nome: "Comunidades", valor: "COMUNIDADES" },
];

const acoes = ref([]);

function validarTelefone() {
  const raw = userData.value.telefone.replace(/\D/g, "");
  if (userData.value.telefone && raw.length < 13) {
    erros.value.telefone = true;
    return false;
  }
  erros.value.telefone = false;
  return true;
}

function validarDataNascimento() {
  const data = userData.value.dataNascimento;
  if (data && data > hoje) {
    erros.value.dataNascimento = true;
    return false;
  }
  erros.value.dataNascimento = false;
  return true;
}

async function coletarInformacoes() {
  const response = await usuariosService.getUsuarioLogado();

  nome.value = jwtDecode(window.localStorage.getItem("auth_token")).nome;
  email.value = response.email ?? "Indefinido";
  nacionalidade.value = response.estrangeiro ? "Estrangeiro" : "Brasileiro";

  userData.value.cpf = response.cpf ? formatarCPF(response.cpf) : "Indefinido";
  userData.value.telefone = response.telefone ?? "";
  userData.value.genero = response.genero ?? "";
  userData.value.heteroidentificacao = response.heteroidentificacao ?? "";
  userData.value.dataNascimento = response.dataNascimento ?? "";
  userData.value.escolaridade = response.escolaridade ?? "";
  userData.value.rendaFamiliar = response.rendaFamiliar ?? "";
  userData.value.zonaMoradia = response.zonaMoradia ?? "";
  userData.value.imagemUrl = response.imagemUrl;

  // Pegando a unidade do usuário, se vier "unidade" ou "unidadeId" do back
  userData.value.unidadeId =
    response.unidadeId || (response.unidade && response.unidade.id) || "";

  if (response.imagem?.base64Data) {
    imagemPreview.value = `data:${response.imagem.mimeType};base64,${response.imagem.base64Data}`;
    imagemBase64.value = response.imagem.base64Data;
    imagemMimeType.value = response.imagem.mimeType;
  }

  if (response.telefone === "") {
    verificacaoNumero.value = true;
  }

  const authSigaa = window.localStorage.getItem("autenticadoSigaa");
  if (authSigaa === "autenticado") {
    isSigaaUser.value = true;
    try {
      unidadesDaUfc.value = await unidadesService.getAllUnidades(0, 1000);
    } catch (e) {
      console.error("Erro ao buscar unidades", e);
    }
  }
}

async function coletarAcoesVinculadas() {
  const response = await usuariosService.getAcoesUsuario();
  acoes.value = response;
}

function formatarPeriodoAcao(acao) {
  if (!acao) return "Não informado";
  const inicio =
    acao.dataInicio ||
    acao.data_inicio ||
    acao.inicio_periodo ||
    acao.inicioPeriodo;
  const fim =
    acao.dataFim || acao.data_fim || acao.fim_periodo || acao.fimPeriodo;

  if (inicio && fim) {
    return `${formatarData(inicio)} a ${formatarData(fim)}`;
  } else if (inicio) {
    return `${formatarData(inicio)}`;
  } else if (fim) {
    return `Até ${formatarData(fim)}`;
  }
  return "Não informado";
}

function ativarEdicao() {
  snapshot = { ...userData.value };
  snapshotImagem = {
    preview: imagemPreview.value,
    base64: imagemBase64.value,
    mimeType: imagemMimeType.value,
  };
  modoEditar.value = true;
}

function cancelarEdicao() {
  userData.value = { ...snapshot };
  imagemPreview.value = snapshotImagem.preview;
  imagemBase64.value = snapshotImagem.base64;
  imagemMimeType.value = snapshotImagem.mimeType;
  erros.value.telefone = false;
  erros.value.dataNascimento = false;
  modoEditar.value = false;
}

async function salvarEdicao() {
  const telefoneOk = validarTelefone();
  const dataOk = validarDataNascimento();
  if (!telefoneOk || !dataOk) return;

  try {
    let payload = {};
    Object.entries(userData.value).forEach(([key, value]) => {
      if (userData.value[key] !== snapshot[key]) {
        payload[key] = value;

        if (key === "telefone") {
          payload[key] = value
            .replace(/[^\d+]/g, "")
            .replace(/(\+\d{2})(\d{2})(\d{5})(\d{4})/, "$1$2$3-$4");
        }

        if (key === "imagem" && userData.value[key] === null) {
          payload.removerImagem = true;
        }
      }
    });

    if (imagemBase64.value) {
      payload.imagem = {
        mimeType: imagemMimeType.value,
        base64Data: imagemBase64.value,
      };
    }

    if (Object.keys(payload).length > 0) {
      await usuariosService.editarPerfilUsuarioLogado(payload);

      texto.value = "Perfil atualizado com sucesso!";
      sucesso.value = true;
      aviso.value = true;
    }
  } catch (error) {
    console.error("Erro ao salvar:", error);
    texto.value = "Ocorreu um erro ao salvar. Tente novamente.";
    sucesso.value = false;
    aviso.value = true;
  } finally {
    modoEditar.value = false;
  }
}

function removerImagem() {
  imagemPreview.value = null;
  imagemBase64.value = null;
  imagemMimeType.value = null;
  userData.value.imagemUrl = null;
  userData.value.imagem = null;
  if (inputImagem.value) inputImagem.value.value = "";
}

async function mudarEmail() {
  await usuariosService.alterarEmail(novoEmail.value);

  texto.value =
    "Uma mensagem de confirmação foi enviada ao novo e-mail. Confirme para concluir a alteração.";
  sucesso.value = true;
  aviso.value = true;
  toggleMudarEmail.value = false;
}

function mudarSenha() {
  router.push("/recuperar-senha-perfil");
}

function abrirAcao(acaoId) {
  router.push(`acao/${acaoId}`);
}

onMounted(async () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
  carregando.value = true;
  await coletarInformacoes();
  await coletarAcoesVinculadas();
  carregando.value = false;
});
</script>

<style scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

#perfil-containder {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
  max-width: 1200px;
  margin: 4rem auto 2rem auto;
  padding: 2rem 2.5rem;
  font-family: "Segoe UI", sans-serif;
}

.cabecalho {
  display: flex;
  justify-content: center;
}

.cabecalho div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 93%;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #d9d9d9;
}

.cabecalho h2 {
  font-size: 1.3rem;
  font-weight: 500;
  color: #1a1a1a;
}

.cabecalho p {
  margin: 0;
  color: var(--roxo-claro);
  cursor: pointer;
}

.perfil-header {
  display: flex;
  align-items: flex-start;
  gap: 1.25rem;
  margin-bottom: 2rem;
}

#edicao-credenciais {
  display: flex;
  gap: 20px;
  margin: 10px 0;
}

.btn-editar-credencial {
  background-color: white;
  transition: 300ms;
  border: 2px solid var(--roxo-claro);
  padding: 0 15px;
  border-radius: 10px;
}

.btn-editar-credencial:hover {
  background-color: var(--roxo-claro);
  color: white;
  transition: 300ms;
}

/* ── Imagem de perfil ── */
.img-perfil {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 154px;
  height: 154px;
  flex-shrink: 0;
}

.img-perfil img {
  width: 154px;
  height: 154px;
  border-radius: 50%;
  object-fit: cover;
}

.img-perfil.editavel {
  cursor: pointer;
}

.img-perfil.editavel img {
  transition: filter 0.2s;
}

.img-perfil.editavel:hover img {
  filter: brightness(0.75);
}

.icone-editar-foto {
  position: absolute;
  bottom: 15px;
  right: 5px;
  background: #7c5cbf;
  color: #fff;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  pointer-events: none;
}
/* ─────────────────────── */

.nome {
  display: flex;
  align-items: center;
  gap: 2rem;
  padding-top: 20px;
}

.nome-email h2 {
  font-size: 1.6rem;
  font-weight: 500;
  color: #1a1a1a;
}

.nome-email p {
  font-size: 0.88rem;
  color: #666;
  margin-top: 0.2rem;
}

.nacionalidade p {
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #888;
  text-transform: uppercase;
}

.informacoes-perfil {
  margin-bottom: 2rem;
}

.informacoes-perfil h3,
.acoes-perfil h3 {
  font-size: 0.82rem;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #1a1a1a;
  margin-bottom: 1.25rem;
}

.campos-infos {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.6rem 1.5rem;
  padding: 0 1rem;
}

.form-label {
  font-size: 0.8rem;
  color: #555;
  margin-bottom: 0.3rem;
  display: block;
}

.form-control {
  width: 100%;
  padding: 0.55rem 0.85rem;
  border: 1.5px solid #b0aee8;
  border-radius: 8px;
  background-color: #ebebeb;
  color: #444;
  font-size: 0.88rem;
  font-family: inherit;
  outline: none;
  transition:
    border-color 0.2s,
    background-color 0.2s;
}

.form-control:disabled {
  opacity: 1;
  cursor: default;
  background-color: #ebebeb;
  border-color: #b0aee8;
}

.form-control:not(:disabled) {
  background-color: #fff;
  border-color: #7c5cbf;
  cursor: auto;
}

.form-control:not(:disabled):focus {
  border-color: #5a3fa0;
  box-shadow: 0 0 0 3px rgba(124, 92, 191, 0.15);
}

input[type="date"]:disabled {
  color: #444;
  -webkit-text-fill-color: #444;
}

select.form-control {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

select.form-control:not(:disabled) {
  -webkit-appearance: auto;
  -moz-appearance: auto;
  appearance: auto;
  cursor: pointer;
}

select.form-control:disabled {
  background-color: #ebebeb !important;
  border-color: #b0aee8 !important;
  color: #444 !important;
  opacity: 1 !important;
}

/* Validação */
.input-invalido {
  border-color: #e53e3e !important;
  background-color: #fff5f5 !important;
}

.msg-erro {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: #e53e3e;
}

/* Minhas Ações */
.acoes-perfil {
  margin-bottom: 2rem;
}

.acoes-vinculadas {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0 1rem;
  max-height: 320px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #b0aee8 #f0f0f0;
}

.acoes-vinculadas::-webkit-scrollbar {
  width: 6px;
}

.acoes-vinculadas::-webkit-scrollbar-track {
  background: #f0f0f0;
  border-radius: 4px;
}

.acoes-vinculadas::-webkit-scrollbar-thumb {
  background: #b0aee8;
  border-radius: 4px;
}

.acao-card {
  border: 1.5px solid #b0aee8;
  border-radius: 8px;
  background-color: #ebebeb;
  padding: 0.75rem 1rem;
  font-size: 0.88rem;
  color: #444;
  line-height: 1.7;
  cursor: pointer;
  transition:
    transform 0.3s,
    box-shadow 0.3s;
}

.acao-card:hover {
  transform: scale(1.005);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.12);
}

.acao-card span {
  font-weight: 600;
  color: #333;
}

/* Botões */
.acoes-botoes {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.5rem;
}

.btn-editar,
.btn-salvar {
  padding: 0.55rem 2.5rem;
  background-color: #7c5cbf;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-editar:hover,
.btn-salvar:hover {
  background-color: #6a4aad;
}

.btn-cancelar {
  padding: 0.55rem 2.5rem;
  background-color: #fff;
  color: #7c5cbf;
  border: 1.5px solid #7c5cbf;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-cancelar:hover {
  background-color: #f3eeff;
}

.btn-remover-foto {
  position: absolute;
  bottom: -15px;
  background: #e53e3e;
  color: #fff;
  border: none;
  border-radius: 6px;
  width: auto;
  height: 26px;
  padding: 0 7px;
  font-size: 0.7rem;
  font-weight: bold;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.25);
  transition: background-color 0.2s;
  z-index: 2;
}

.btn-remover-foto:hover {
  background-color: #c53030;
}

.campos-form-container {
  width: 90%;
  height: auto;
}

.form {
  width: 500px;
  min-height: 0;
  height: auto;
}

#voltar {
  width: 500px;
}
</style>
